export default "__VITE_ASSET__ygg$lDJF__"